import React, { useState, useRef } from 'react';

import Icon from '../../../components/AppIcon';

const getYouTubeEmbedUrl = (url, autoplay = false) => {
  if (!url) return null;
  try {
    if (url?.includes('youtube.com/embed/')) {
      const base = url?.split('?')?.[0];
      return autoplay ? `${base}?autoplay=1&mute=0` : `${base}?mute=0`;
    }
    let videoId = null;
    const shortMatch = url?.match(/youtu\.be\/([a-zA-Z0-9_-]{11})/);
    if (shortMatch) videoId = shortMatch?.[1];
    const watchMatch = url?.match(/[?&]v=([a-zA-Z0-9_-]{11})/);
    if (watchMatch) videoId = watchMatch?.[1];
    const shortsMatch = url?.match(/youtube\.com\/shorts\/([a-zA-Z0-9_-]{11})/);
    if (shortsMatch) videoId = shortsMatch?.[1];
    if (videoId) {
      return autoplay
        ? `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=0`
        : `https://www.youtube.com/embed/${videoId}?mute=0`;
    }
    return null;
  } catch {
    return null;
  }
};

const getYouTubeThumbnail = (url) => {
  if (!url) return null;
  try {
    let videoId = null;
    const shortMatch = url?.match(/youtu\.be\/([a-zA-Z0-9_-]{11})/);
    if (shortMatch) videoId = shortMatch?.[1];
    const watchMatch = url?.match(/[?&]v=([a-zA-Z0-9_-]{11})/);
    if (watchMatch) videoId = watchMatch?.[1];
    const shortsMatch = url?.match(/youtube\.com\/shorts\/([a-zA-Z0-9_-]{11})/);
    if (shortsMatch) videoId = shortsMatch?.[1];
    const embedMatch = url?.match(/youtube\.com\/embed\/([a-zA-Z0-9_-]{11})/);
    if (embedMatch) videoId = embedMatch?.[1];
    return videoId ? `https://img.youtube.com/vi/${videoId}/hqdefault.jpg` : null;
  } catch {
    return null;
  }
};

const SurpriseContent = ({ title, content, actionText, onAction, videoUrl, surpriseType }) => {
  const [hasActed, setHasActed] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const videoRef = useRef(null);

  const embedUrlBase = getYouTubeEmbedUrl(videoUrl, false);
  const embedUrlAutoplay = getYouTubeEmbedUrl(videoUrl, true);
  const thumbnail = getYouTubeThumbnail(videoUrl);

  const handleAction = () => {
    setHasActed(true);
    if (onAction) {
      onAction();
    }
  };

  const handlePlayClick = () => {
    setIsPlaying(true);
  };

  return (
    <div className="space-y-6 md:space-y-8">
      <div className="flex items-start gap-4">
        <div className="w-12 h-12 md:w-14 md:h-14 lg:w-16 lg:h-16 rounded-xl flex items-center justify-center flex-shrink-0 bg-gradient-to-br from-purple-500 to-pink-500">
          <Icon name="Sparkles" size={24} color="white" />
        </div>
        <div className="flex-1">
          <h3 className="text-xl md:text-2xl lg:text-3xl font-heading font-semibold text-foreground mb-3 md:mb-4">
            {title || 'Sürpriz Gün!'}
          </h3>
          <div className="p-6 md:p-8 lg:p-10 rounded-xl bg-gradient-to-br from-purple-500/10 to-pink-500/10 border-2 border-purple-500/20">
            <p className="text-base md:text-lg lg:text-xl text-foreground leading-relaxed">
              {content || 'Bugün özel bir gün! Trafikkokusu ailesinin bir parçası olduğun için sana özel bir sürprizimiz var. Aşağıdaki butona tıklayarak sürprizini keşfet!'}
            </p>
          </div>
        </div>
      </div>

      {surpriseType === 'video' && embedUrlBase && (
        <div
          ref={videoRef}
          className="relative w-full rounded-xl overflow-hidden border border-purple-500/20"
          style={{ paddingBottom: '56.25%' }}
        >
          {isPlaying ? (
            <iframe
              src={embedUrlAutoplay}
              title={title || 'Sürpriz Video'}
              className="absolute inset-0 w-full h-full"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            />
          ) : (
            <div
              className="absolute inset-0 w-full h-full cursor-pointer group"
              onClick={handlePlayClick}
            >
              {thumbnail && (
                <img
                  src={thumbnail}
                  alt={title || 'Video thumbnail'}
                  className="w-full h-full object-cover"
                />
              )}
              {!thumbnail && (
                <div className="w-full h-full bg-black/80" />
              )}
              <div className="absolute inset-0 flex items-center justify-center bg-black/30 group-hover:bg-black/40 transition-colors">
                <div className="w-16 h-16 md:w-20 md:h-20 rounded-full bg-red-600 flex items-center justify-center shadow-lg group-hover:scale-110 transition-transform">
                  <svg viewBox="0 0 24 24" fill="white" className="w-8 h-8 md:w-10 md:h-10 ml-1">
                    <path d="M8 5v14l11-7z" />
                  </svg>
                </div>
              </div>
            </div>
          )}
        </div>
      )}

      {surpriseType === 'video' && videoUrl && !embedUrlBase && (
        <div className="flex items-center gap-3 p-4 rounded-xl bg-destructive/10 border border-destructive/20">
          <Icon name="AlertCircle" size={20} color="var(--color-destructive)" />
          <p className="text-sm text-destructive">Video yüklenemedi. Geçersiz YouTube linki.</p>
        </div>
      )}

      <div className="space-y-4">

      </div>
    </div>
  );
};

export default SurpriseContent;